@if (loading()) {
  <div class="tt-anchor-links-popover_spinner">
    <tt-spinner [size]="30" />
  </div>
}

@if (selectedGuideline()) {
  <tt-anchor-link-search-popover-guideline
    [guideline]="selectedGuideline()"
    (clearSelectedGuideline)="clearSelectedGuideline()"
    (linkSelected)="selectLink($event)" />
} @else {
  @if (!data?.searchFormControl) {
    <tt-form-field class="tt-anchor-links-popover_search">
      <input
        ttInput
        [placeholder]="'SearchForGuidelines' | transloco"
        [(ngModel)]="searchTerm"
        (ngModelChange)="handleSearchTermChange($event)" />
    </tt-form-field>
  }

  @if (hasResults()) {
    <div class="tt-anchor-links-popover_results">
      @if (searchLinkResults().length > 0) {
        <div class="tt-anchor-links-popover_divider">
          {{ 'Links' | transloco }}
        </div>

        @for (link of searchLinkResults(); track link.id) {
          <div class="tt-anchor-links-popover_result" (click)="selectLink(link)">
            @if (link.toElementType === LinkElementType.Chapter) {
              <mat-icon
                class="tt-anchor-links-popover_result-icon"
                [icon]="'bookmark'"
                [iconSize]="20"
                [ttTooltip]="'Chapter' | transloco" />
            }
            @if (link.toElementType === LinkElementType.Component) {
              <mat-icon
                class="tt-anchor-links-popover_result-icon"
                [icon]="'component'"
                [iconSize]="20"
                [ttTooltip]="'Component' | transloco" />
            }
            @if (link.toElementType === LinkElementType.FlowchartNode) {
              <mat-icon
                class="tt-anchor-links-popover_result-icon"
                [icon]="'git-fork'"
                [iconSize]="20"
                [ttTooltip]="'FlowchartElement' | transloco" />
            }
            <div
              class="tt-anchor-links-popover_result-container"
              [attr.data-testid]="'anchor-link_search-result_' + link.title.split(' ').join('-')">
              <span class="tt-anchor-links-popover_result-title">{{ link.title }}</span>
              <span class="tt-anchor-links-popover_result-path">{{ link.path }}</span>
            </div>
          </div>
        }
      }

      @if (searchGuidelineResults().length > 0) {
        <div class="tt-anchor-links-popover_divider">
          {{ 'Guidelines' | transloco }}
        </div>

        <div class="tt-anchor-links-popover_guidelines">
          @for (link of searchGuidelineResults(); track link.uniqueId) {
            @if (!$first) {
              <div class="tt-anchor-links-popover_guideline-divider"></div>
            }
            <div class="tt-anchor-links-popover_guideline" [attr.data-testid]="'anchor-link_search-result-' + link.id">
              @if (link.toElementType === LinkElementType.Guideline) {
                <mat-icon
                  class="tt-anchor-links-popover_guideline-icon"
                  [icon]="'book'"
                  [iconSize]="16"
                  [ttTooltip]="'Guideline' | transloco" />
              }

              <div class="tt-anchor-links-popover_guideline-container">
                <div class="tt-anchor-links-popover_guideline-title">{{ link.title }}</div>
                <div class="tt-anchor-links-popover_guideline-selector">
                  <button class="tt-anchor-links-popover_guideline-selector-button"
                    size="small"
                    ttButton
                    type="useParentWidth"
                    variant="primary"
                    (click)="selectLink(link)">
                    <span>{{ 'LinkToFullGuideline' | transloco }}</span>
                  </button>
                  <button class="tt-anchor-links-popover_guideline-selector-button"
                    size="small"
                    ttButton
                    type="useParentWidth"
                    variant="secondary"
                    (click)="linkToGuidelineSection(link)">
                    <span>{{ 'LinkToSpecific' | transloco }}</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else if (searchTerm().length > 0 || data?.searchFormControl?.value.length > 0) {
    <div class="tt-anchor-links-popover_no-results">
      <mat-icon class="tt-anchor-links-popover_no-results-icon" [icon]="'search-x'" [iconSize]="24" />
      {{ 'NoResultsFoundInSearch' | transloco }}
    </div>
  }
}
